/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientAndContact } from './ClientAndContact';
import {
    ClientAndContactFromJSON,
    ClientAndContactFromJSONTyped,
    ClientAndContactToJSON,
} from './ClientAndContact';

/**
 * Payload of enumerated clients with contact type of client contact corresponding to an actor
 * @export
 * @interface ClientsForActor
 */
export interface ClientsForActor {
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof ClientsForActor
     */
    actorRID: string;
    /**
     * 
     * @type {Array<ClientAndContact>}
     * @memberof ClientsForActor
     */
    clientsAndContact: Array<ClientAndContact>;
}

/**
 * Check if a given object implements the ClientsForActor interface.
 */
export function instanceOfClientsForActor(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "actorRID" in value;
    isInstance = isInstance && "clientsAndContact" in value;

    return isInstance;
}

export function ClientsForActorFromJSON(json: any): ClientsForActor {
    return ClientsForActorFromJSONTyped(json, false);
}

export function ClientsForActorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientsForActor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actorRID': json['actorRID'],
        'clientsAndContact': ((json['clientsAndContact'] as Array<any>).map(ClientAndContactFromJSON)),
    };
}

export function ClientsForActorToJSON(value?: ClientsForActor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'actorRID': value.actorRID,
        'clientsAndContact': ((value.clientsAndContact as Array<any>).map(ClientAndContactToJSON)),
    };
}

